import { type PropsWithChildren, useRef } from 'react';
import classNames from 'classnames';

import createInjectableComponent from '../../modules/createInjectableComponent';
import { useScrolledDown } from '../../hooks/useScrolledDown';

import styles from './Header.module.scss';

export const HeaderIdentifier = Symbol(`HEADER`);

export type HeaderProps = {
  className?: string;
  searchActive: boolean;
};

const Header = ({ children, className, searchActive }: PropsWithChildren<HeaderProps>) => {
  const headerRef = useRef<HTMLElement>(null);

  useScrolledDown(0, 500, (progress) => {
    const el = headerRef.current;
    if (!el) return;
    el.style.setProperty('--scroll-progress', progress.toFixed(3));
  });

  const headerClassName = classNames(styles.header, className, {
    [styles.searchActive]: searchActive,
  });

  return (
    <header ref={headerRef} className={headerClassName}>
      <div className={styles.container}>{children}</div>
    </header>
  );
};

export default createInjectableComponent(HeaderIdentifier, Header);
